import React from 'react';

import styled from 'styled-components';

import theme from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import CategoryName from './CategoryName';
import getAssetUrl from './helpers/getAssetUrl';
import InlineStatusColorIndicator from './InlineStatusColorIndicator';
import { Asset } from './types';
import BlockRemoveButton from '../../BlockRemoveButton';
import ReferencePickerPlugin from '../../types/ReferencePickerPlugin';
import UnstyledAnchor from '../../UnstyledAnchor';

const Container = styled(UnstyledAnchor)`
  background-color: ${theme.colors.white};
  border-bottom: 1px solid ${theme.colors.charcoal100};
  cursor: pointer;
  display: flex;
  height: 90px;
  justify-content: space-between;
  align-items: center;
  padding: 14px;

  &:hover .AssetsEntityBlock__remove-button {
    visibility: visible;
  }
`;

const Details = styled.div`
  display: flex;
  flex-direction: column;
  height: 62px;
  justify-content: space-evenly;
  overflow: hidden;
`;

const Name = styled.div(theme.typography.heading4);

const Status = styled.div({
  ...theme.typography.labelSmall,
  marginTop: '4px',
});

const AssetsEntityBlock: ReferencePickerPlugin<Asset>['EntityBlock'] = ({
  entity: asset,
  projectId,
  onRemoveClick,
  onReferenceClickAnalytics,
}) => (
  <Container
    onClick={onReferenceClickAnalytics}
    href={getAssetUrl(projectId, asset.id)}
  >
    <Details>
      <Name>
        <OverflowTooltip>{asset.clientAssetId}</OverflowTooltip>
      </Name>
      {asset.category && <CategoryName category={asset.category} />}
      {asset.status && (
        <Status>
          <OverflowTooltip>
            <InlineStatusColorIndicator color={asset.status.color} />
            {asset.status.label}
          </OverflowTooltip>
        </Status>
      )}
    </Details>
    {onRemoveClick && (
      <BlockRemoveButton
        className="AssetsEntityBlock__remove-button"
        style={{ visibility: 'hidden' }}
        onClick={onRemoveClick}
      />
    )}
  </Container>
);

export default AssetsEntityBlock;
